<template>
  <div>
    <h-description
      v-for="modifier in modifiers"
      :key="modifier.id"
      :name="modifier.name"
      :price="modifier.price * quantity"
      :paid="paid"
    />
  </div>
</template>

<script>
  import HDescription from './ItemDescription'

  export default {
    components: {
      HDescription,
    },

    props: {
      quantity: {
        required: true,
        type: Number,
      },
      modifiers: {
        required: true,
        type: Array,
      },
      paid: {
        required: false,
        type: Boolean,
        default: false,
      },
    },
  }
</script>
